import * as yup from 'yup';

export const FormikFormSchema = yup.object({
  fromDate: yup.string().required('From Date is required'),
  toDate: yup.string().required('From Date is required'),
});
